import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add-verification",
  "use": "add-verification-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"add-verification\">\n    <path fill=\"#03ADEF\" fill-rule=\"evenodd\" d=\"M9.5 4v4.5H14v1H9.5V14h-1V9.5H4v-1h4.5V4h1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol